<div class="not-found-container">
  <div class="title">Error 404</div>
  <div class="description">It seems you are searching for something that does not exist...</div>
  <div class="logo"><span class="icon-logo-box-hex"></span></div>
  <div class="logo-title">SKILL<span class="font-weight-bold">HOP</span></div>
</div>
